import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React__default__default from 'react';
import PropTypes__default from 'prop-types';
import styles from '../../node_modules/@flixbus/honeycomb/dist/scss/components/select-group.scss.js';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import useComponentId from '../../hooks/use-component-id/use-component-id.js';
import { InputInfoChildren, InputInfo } from '../_atoms/input-info/input-info.js';
import Label from '../_atoms/label/label.js';
import { Injecss } from '../../packages/injecss/injecss.js';

var bem = HoneyBem.init('select-group', styles);
var SelectGroup = function (_a) {
  var disabled = _a.disabled,
    error = _a.error,
    multi = _a.multi,
    label = _a.label,
    info = _a.info,
    infoError = _a.infoError,
    options = _a.options,
    extraClasses = _a.extraClasses,
    rest = __rest(_a, ["disabled", "error", "multi", "label", "info", "infoError", "options", "extraClasses"]);
  /**
   * Generates a dynamic prefix for the component ID in the following format:
   * N * option.id[first-letter]+[last-letter]
   */
  var idPrefix = options.map(function (option) {
    return option.id && "".concat(option.id.toString().charAt(0)).concat(option.id.toString().charAt(option.id.toString().length - 1));
  }).join('');
  var componentId = useComponentId(idPrefix);
  return /*#__PURE__*/React__default__default.createElement("fieldset", __assign({
    className: bem.b({
      error: error,
      disabled: disabled
    }, extraClasses)
  }, rest), label && /*#__PURE__*/React__default__default.createElement(Label, {
    Elem: "legend",
    extraClasses: bem.e('label'),
    text: label
  }), /*#__PURE__*/React__default__default.createElement("ul", {
    className: bem.e('items')
  }, options && options.map(function (_a) {
    var subId = _a.id,
      name = _a.name,
      value = _a.value,
      subLabel = _a.label,
      subDisabled = _a.disabled,
      restInOption = __rest(_a, ["id", "name", "value", "label", "disabled"]);
    return /*#__PURE__*/React__default__default.createElement("li", {
      className: bem.e('item', {
        disabled: subDisabled
      }),
      key: subId
    }, /*#__PURE__*/React__default__default.createElement("input", __assign({
      disabled: disabled || subDisabled,
      type: multi ? 'checkbox' : 'radio',
      value: value,
      name: name,
      id: subId.toString(),
      "aria-errormessage": "infoError-".concat(componentId)
    }, error && {
      'aria-invalid': true
    }, info && {
      'aria-describedby': "info-".concat(componentId)
    }, restInOption)), /*#__PURE__*/React__default__default.createElement("label", {
      htmlFor: subId.toString()
    }, subLabel));
  })), /*#__PURE__*/React__default__default.createElement(InputInfo, {
    error: true,
    id: componentId,
    className: bem.e('info')
  }, error ? infoError : ''), info && /*#__PURE__*/React__default__default.createElement(InputInfo, {
    id: componentId,
    className: bem.e('info')
  }, info));
};
SelectGroup.displayName = 'SelectGroup';
SelectGroup.defaultProps = {
  disabled: false,
  error: false,
  extraClasses: '',
  info: undefined,
  infoError: undefined,
  multi: false,
  label: undefined
};
SelectGroup.propTypes = {
  disabled: PropTypes__default.bool,
  error: PropTypes__default.bool,
  extraClasses: PropTypes__default.string,
  label: function (_a) {
    var ariaLabel = _a["aria-label"],
      label = _a.label;
    // if no aria label nor label throw validation error
    return !ariaLabel && !label ? new Error('Either a label or aria-label are required for SelectGroup') : null;
  },
  info: InputInfoChildren,
  infoError: InputInfoChildren,
  multi: PropTypes__default.bool,
  options: PropTypes__default.arrayOf(PropTypes__default.shape({
    value: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]).isRequired,
    id: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]).isRequired,
    name: PropTypes__default.string.isRequired,
    label: PropTypes__default.node.isRequired,
    disabled: PropTypes__default.bool
  })).isRequired
};
var selectGroup = Injecss(SelectGroup, styles);

export { SelectGroup, selectGroup as default };
